import { deprecatedApi, servicesApi } from '@/services/api/deprecated';
import type { Account, User } from './';

export const getAuthCurrent = async () => {
  const { data } = await deprecatedApi.get<{ account: Account; user: User }>('/auth/current');
  return data;
};

export const getPipelinesWorkspaceAuth = async (workspaceId: number) => {
  const { data } = await deprecatedApi.get<{ account: Account; user: User }>(`/cdp_workspaces/${workspaceId}/auth`);
  return data;
};

export const getJourneysWorkspaceAuth = async (workspaceId: number) => {
  const { data } = await deprecatedApi.get<{ account: Account; user: User }>(`/cio_workspaces/${workspaceId}/auth`);
  return data;
};

export const getAccountAuth = async (accountId: number) => {
  const { data } = await deprecatedApi.get<{ account: Account; user: User }>(`/accounts/${accountId}/auth`);
  return data;
};

export const getAccount = async (workspaceId: number) => {
  const { data } = await servicesApi.get<{ account: Account; user: User }>(`/account_by_environment/${workspaceId}`);
  return data;
};
